import React, { Fragment, useState, useEffect } from "react";

import {
  ResultProvider,
  getResultOrigin,
  TYPES,
  SUBTYPES,
  Bars
} from "@atresmedia/elections_modules_library";
import cintillos from "../../components/cintillo/cintillos";
import "./bars.scss";

const BarsContainer = ({ match }) => {
  const { year, type, electionNumber, placesIds, community } = match.params;

  const [resultOrigin, setResultOrigin] = useState({});

  // Exluimos de la comparativa MareaG
  const excludes = [9, 13];

  const place = type === TYPES.REGIONAL ? community : placesIds;
  const Cintillo = cintillos[place];

  useEffect(() => {
    getResultOrigin(year, type, electionNumber, place)
      .then(historicResult => {
        setResultOrigin(historicResult);
      })
      .catch(err => {});
  }, [year, type, electionNumber]);

  return (
    <div className="bars_page">
      <Cintillo rightSide="COMPARATIVA DE ESCAÑOS 2020-2016"></Cintillo>
      {resultOrigin && resultOrigin.primary && (
        <ResultProvider
          electionPlace={place}
          active={resultOrigin.primary.active}
          year={year}
          type={type}
          subtype={type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE}
          electionNumber={electionNumber}
          placeId={place}
        >
          {dataResult => (
            <ResultProvider
              electionPlace={place}
              active={resultOrigin.historic.active}
              year={resultOrigin.historic.year}
              type={type}
              subtype={
                type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE
              }
              electionNumber={resultOrigin.historic.numElection}
              placeId={place}
            >
              {oldData => (
                <div className="barsWrapper">
                  <Bars
                    currentData={dataResult}
                    pastData={oldData}
                    year={year}
                    electionNumber={electionNumber}
                    electionType={type}
                    placeId={place}
                    excludes={excludes}
                  />
                </div>
              )}
            </ResultProvider>
          )}
        </ResultProvider>
      )}
    </div>
  );
};

export default BarsContainer;
